(function () {
  'use strict';

  var summaryId = 'cart-add-confirmation';
  var pending = null;
  var deliveryTimer;
  var expiryTimer;
  var observedDrawers = new WeakSet();

  function isOpen(drawer) {
    return drawer && drawer.getAttribute('aria-hidden') !== 'true' &&
      !drawer.closest('[hidden], [inert]') && drawer.getClientRects().length > 0 &&
      (drawer.id === 'rebuy-cart' ? drawer.classList.contains('is-visible') : drawer.classList.contains('show'));
  }

  function activeDrawer() {
    var rebuy = document.getElementById('rebuy-cart');
    if (rebuy) return isOpen(rebuy) ? rebuy : null;
    return Array.from(document.querySelectorAll('#offcanvas_cart')).find(isOpen);
  }

  function clearTimers() {
    clearTimeout(deliveryTimer);
    clearTimeout(expiryTimer);
    deliveryTimer = null;
  }

  function removeDescription(drawer) {
    var ids = (drawer.getAttribute('aria-describedby') || '').split(/\s+/).filter(function (id) {
      return id && id !== summaryId;
    });
    if (ids.length) drawer.setAttribute('aria-describedby', ids.join(' '));
    else drawer.removeAttribute('aria-describedby');
  }

  function reset() {
    clearTimers();
    pending = null;
    document.querySelectorAll('[data-cart-add-confirmation]').forEach(function (summary) {
      var drawer = summary.closest('[role="dialog"]');
      if (drawer) removeDescription(drawer);
      summary.remove();
    });
  }

  function getSummary(drawer) {
    document.querySelectorAll('[data-cart-add-confirmation]').forEach(function (previous) {
      if (drawer.contains(previous)) return;
      var previousDrawer = previous.closest('[role="dialog"]');
      if (previousDrawer) removeDescription(previousDrawer);
      previous.remove();
    });
    var summary = drawer.querySelector('[data-cart-add-confirmation]');
    if (!summary) {
      summary = document.createElement('p');
      summary.id = summaryId;
      summary.className = 'sr-only';
      summary.tabIndex = -1;
      summary.setAttribute('data-cart-add-confirmation', '');
      summary.setAttribute('role', 'status');
      summary.setAttribute('aria-live', 'off');
      summary.setAttribute('aria-atomic', 'true');
      (drawer.querySelector('.rebuy-cart__flyout') || drawer).prepend(summary);
      summary.addEventListener('keydown', function (event) {
        if (event.key !== 'Tab' || !event.shiftKey) return;
        var controls = Array.from(drawer.querySelectorAll('a[href], button, input, select, textarea, [tabindex]')).filter(function (element) {
          return element.tabIndex >= 0 && !element.matches(':disabled, [data-redo-cart-focus-end]') &&
            !element.closest('[hidden], [inert]') && element.getClientRects().length > 0;
        });
        if (controls.length) {
          event.preventDefault();
          event.stopPropagation();
          controls[controls.length - 1].focus();
        }
      });
    }
    var ids = (drawer.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
    if (ids.indexOf(summaryId) === -1) {
      ids.push(summaryId);
      drawer.setAttribute('aria-describedby', ids.join(' '));
    }
    return summary;
  }

  function schedule(restart) {
    if (!pending || (deliveryTimer && !restart)) return;
    var drawer = activeDrawer();
    if (!drawer) return;
    pending.drawer = drawer;
    getSummary(drawer);
    clearTimeout(deliveryTimer);
    var addition = pending;
    deliveryTimer = setTimeout(function () {
      deliveryTimer = null;
      if (pending !== addition || !isOpen(drawer) || activeDrawer() !== drawer) return;
      var summary = getSummary(drawer);
      var fallback = document.getElementById('cart-add-announcer');
      if (fallback) fallback.textContent = '';
      summary.setAttribute('aria-live', addition.focus ? 'off' : 'polite');
      if (summary.textContent !== addition.message) {
        summary.textContent = addition.message;
        summary.setAttribute('aria-label', addition.message);
      }
      addition.delivered = true;
      addition.drawer = drawer;
      if (addition.focus && document.activeElement !== summary) summary.focus({ preventScroll: true });
    }, 180);
  }

  function watchDrawer(drawer) {
    if (observedDrawers.has(drawer)) return;
    observedDrawers.add(drawer);
    new MutationObserver(function () {
      if (pending && pending.drawer === drawer && !isOpen(drawer)) reset();
      else if (pending && !pending.delivered) schedule(false);
    }).observe(drawer, { attributes: true, attributeFilter: ['aria-hidden', 'class', 'inert'], childList: true, subtree: true });
  }

  function scan() {
    document.querySelectorAll('#rebuy-cart, #offcanvas_cart').forEach(watchDrawer);
    if (pending) schedule(false);
  }

  window.CartAddAnnouncement = {
    announce: function (message) {
      clearTimers();
      pending = { message: message, focus: true, delivered: false, drawer: null };
      var addition = pending;
      var fallback = document.getElementById('cart-add-announcer');
      if (fallback) fallback.textContent = '';
      scan();
      expiryTimer = setTimeout(function () {
        if (pending !== addition) return;
        if (!addition.delivered && fallback) fallback.textContent = message;
        pending = null;
      }, 1800);
    }
  };

  document.addEventListener('rebuy:smartcart.show', function () { scan(); schedule(true); });
  document.addEventListener('rebuy:smartcart.ready', scan);
  document.addEventListener('rebuy:smartcart.hide', reset);
  document.addEventListener('focusin', function (event) {
    if (!pending || !pending.focus) return;
    if (!pending.delivered || event.target.matches('#rebuy-cart, #rebuy-cart-close, #offcanvas_cart, .rebuy-cart__flyout-close')) schedule(true);
  });
  function userInteraction() {
    if (pending) pending.focus = false;
  }
  document.addEventListener('keydown', userInteraction, true);
  document.addEventListener('pointerdown', userInteraction, true);
  new MutationObserver(scan).observe(document.body, { childList: true });
  scan();
}());
